import { render, staticRenderFns } from "./MonthEvents.vue?vue&type=template&id=146bacf0&"
import script from "./MonthEvents.vue?vue&type=script&lang=js&"
export * from "./MonthEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports